import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from 'lodash';
import { IAgent } from "./agents.interface";
import { AuthService } from "../../../shared/services/auth.service";
import { UtilsService } from "../../../shared/services/utils.service";
import { HttpService } from "../../../../http.service";
import { apiURL, EnvConfig } from "../../../../env-config";

@Injectable()
export class AgentsService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
    private _AuthService: AuthService,
  ) { }

  getAgents(filter?: any): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_AGENTS)}${queryParams}`);
  }

  getAgent(agent: IAgent | string): Observable<any> {
    let id = (typeof agent == 'string') ? agent : agent._id;
    return this._http.get(`${apiURL(EnvConfig.API_AGENTS)}/${id}`);
  }

  createAgent(agent: IAgent): Observable<any> {
    return this._http.post(`${apiURL(EnvConfig.API_AGENTS)}`, agent);
  }

  updateAgent(agent: IAgent): Observable<any> {
    let id = agent._id;
    delete agent._id;
    return this._http.patch(`${apiURL(EnvConfig.API_AGENTS)}/${id}`, agent);
  }

  deleteAgent(agent: IAgent | string, hardDelete: boolean = false): Observable<void> {
    let id = (typeof agent == 'string') ? agent : agent._id;
    if (hardDelete) return this._http.delete(`${apiURL(EnvConfig.API_AGENTS)}/${id}`);
    return this._http.delete(`${apiURL(EnvConfig.API_AGENTS)}/${id}/delete`);
  }

  restoreAgent(agent: IAgent | string): Observable<void> {
    let id = (typeof agent == 'string') ? agent : agent._id;
    return this._http.post(`${apiURL(EnvConfig.API_AGENTS)}/${id}/restore`, null);
  }
}